import { render, staticRenderFns } from "./OverlayLoader.vue?vue&type=template&id=70d0a862&scoped=true&"
import script from "./OverlayLoader.vue?vue&type=script&lang=ts&"
export * from "./OverlayLoader.vue?vue&type=script&lang=ts&"
import style0 from "./OverlayLoader.vue?vue&type=style&index=0&id=70d0a862&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d0a862",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70d0a862')) {
      api.createRecord('70d0a862', component.options)
    } else {
      api.reload('70d0a862', component.options)
    }
    module.hot.accept("./OverlayLoader.vue?vue&type=template&id=70d0a862&scoped=true&", function () {
      api.rerender('70d0a862', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/OverlayLoader.vue"
export default component.exports